import React from 'react';
import Icon from '../Icon';
import T from './EditableText';

/**
 * Aufzählung mit Haken — die Standardliste der Website für Leistungen.
 *
 * Lag ursprünglich als lokale Komponente in `pages/Betreuung24h.tsx`. Herausgelöst,
 * als die Kampagnen-Landingpage dieselbe Liste brauchte: Die Klasse `.tick` steht
 * seit jeher in `website.css`, war von außen aber nicht als Bauteil zu erkennen —
 * mit dem Ergebnis, dass sie beim zweiten Mal versehentlich neu erfunden und ihr
 * Name dabei überschrieben wurde.
 */
const TickList: React.FC<{
  /** Textschlüssel der Einträge. */
  keys: string[];
  /** Mindestbreite einer Spalte; bestimmt, wie viele nebeneinander passen. */
  min?: string;
}> = ({ keys, min = '220px' }) => (
  <div className="autogrid" style={{ ['--min' as string]: min, gap: 12 }}>
    {keys.map((key) => (
      <div className="tick" key={key}>
        <Icon name="check" size={20} />
        <T k={key} />
      </div>
    ))}
  </div>
);

export default TickList;
